<script setup lang="ts">
defineProps<{
	label?: string;
	required?: boolean;
}>();
</script>

<template>
	<span class="min-w-0 truncate"><slot>{{ label }}</slot><sup v-if="required" class="text-error" aria-hidden="true" :aria-label="$t('common.required')">*</sup></span>
</template>
